// ============================================================
// Varlık bazlı yazma işlemleri
//
// Görünümler yol dizisi kurmaz — buradaki adlandırılmış işlemleri
// çağırır. Denetim izinde okunur etiket de burada üretilir.
// ============================================================

import { subeninKiracisi } from "../domain/context.js";
import { commit } from "./index.js";
import { BUGUN } from "../config.js";

// Yol kiracıdan başlar: tenants/{tid}/branches/{bid}/...
// Kiracı, şube kimliğinden çözülür; çağıranın ayrıca taşımasına gerek yok.
const sube = branchId => {
  const kiraci = subeninKiracisi(branchId);
  if (!kiraci) throw new Error(`Şube bulunamadı: ${branchId}`);
  return ["tenants", { id: kiraci.id }, "branches", { id: branchId }];
};

// ---------- Yoklama ----------
//
// YOL GÜNÜ TAŞIR. Eskiden [...sube, "attendance", id] idi ve bu yol
// her zaman BUGÜNÜN kaydına gidiyordu: dünkü mutasyon bugün yeniden
// oynatılınca bugünün yoklamasını işaretliyordu. BUGUN sabit
// "2026-08-05" olduğu sürece görünmüyordu — her gün aynı gündü.
// Gerçek tarihe geçilince ortaya çıktı.
//
// Bellekte attendanceLog[gun][studentId], Firestore'da
// attendance/{gun}/records/{sid} (bkz. repo/projeksiyon.js).
export const Yoklama = {
  durumDegistir(branchId, ogrenci, yeni, alan, gun = BUGUN) {
    return commit({
      op: "set",
      path: [...sube(branchId), "attendanceLog", gun, ogrenci.id],
      after: alan,
      branchId,
      entity: "attendance",
      entityId: ogrenci.id,
      label: `${ogrenci.name} yoklaması → ${yeni}`,
    });
  },

  /**
   * Çocuğun çıkışını kaydeder — kimin aldığı zorunludur (§3 + §4).
   * Teslim alan kişi denetim izine yazılır; "kim aldı" sorusunun
   * cevabı sonradan da bulunabilsin.
   */
  /**
   * @param {object|null} imza  { path } gerçek modda, { dataUrl } demoda
   */
  cikisKaydet(branchId, ogrenci, mevcut, teslimAlan, saat, imza = null, gun = BUGUN) {
    // İmzanın alınıp alınmadığı ETİKETTE yazıyor. Denetim izine
    // bakan kişi kaydı açmadan görebilmeli: imzasız teslimler
    // sonradan sorulacak ilk şey.
    const imzaNotu = imza ? "imzalı" : "imzasız";

    return commit({
      op: "set",
      path: [...sube(branchId), "attendanceLog", gun, ogrenci.id],
      after: {
        ...mevcut,
        out: saat,
        outBy: { name: teslimAlan.name, relation: teslimAlan.relation },
        // Belgeye YOL yazılır, görüntülenebilir URL değil — imza bir
        // delil; token'lı kalıcı bağlantı denetim dışı paylaşıma
        // açık olurdu (bkz. lib/storage-dosyalar.js).
        ...(imza?.path ? { outSignaturePath: imza.path } : {}),
        ...(imza?.dataUrl ? { outSignatureDataUrl: imza.dataUrl } : {}),
      },
      branchId,
      entity: "attendance",
      entityId: ogrenci.id,
      label: `${ogrenci.name} çıkışı — ${teslimAlan.name} (${teslimAlan.relation}) teslim aldı, ${saat} · ${imzaNotu}`,
    });
  },

  /** Çıkışı geri alır — yanlış kişi seçildiyse. */
  cikisGeriAl(branchId, ogrenci, mevcut, gun = BUGUN) {
    return commit({
      op: "set",
      path: [...sube(branchId), "attendanceLog", gun, ogrenci.id],
      after: { ...mevcut, out: null, outBy: null },
      branchId,
      entity: "attendance",
      entityId: ogrenci.id,
      label: `${ogrenci.name} çıkış kaydı geri alındı`,
    });
  },
};

// ---------- Mesajlar ----------
export const Mesajlar = {
  gonder(branchId, thread, metin) {
    const kayit = {
      from: "kurum",
      text: metin,
      time: new Date().toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }),
    };
    return commit({
      op: "push",
      path: [...sube(branchId), "messages", { id: thread.id }, "thread"],
      after: kayit,
      branchId,
      entity: "message",
      entityId: thread.id,
      label: `${thread.parent} ile yazışmaya yanıt yazıldı`,
    });
  },

  okunduIsaretle(branchId, thread) {
    if (!thread.unread) return null;
    return commit({
      op: "set",
      path: [...sube(branchId), "messages", { id: thread.id }, "unread"],
      after: false,
      branchId,
      entity: "message",
      entityId: thread.id,
      label: `${thread.parent} yazışması okundu`,
    });
  },
};

// ---------- Personel ----------
export const Personel = {
  ekle(branchId, kisi) {
    return commit({
      op: "push",
      path: [...sube(branchId), "staff"],
      after: kisi,
      branchId,
      entity: "staff",
      entityId: kisi.id,
      label: `${kisi.name} personel olarak eklendi (${kisi.role})`,
    });
  },

  sinifOgretmeniAta(branchId, sinif, kisi) {
    return commit({
      op: "set",
      path: [...sube(branchId), "classes", { id: sinif.id }, "teacherId"],
      after: kisi.id,
      branchId,
      entity: "class",
      entityId: sinif.id,
      label: `${sinif.name} sınıfına ${kisi.name} öğretmen atandı`,
    });
  },
};

// ---------- Başvurular ----------
export const Basvurular = {
  ekle(branchId, basvuru) {
    return commit({
      op: "push",
      path: [...sube(branchId), "applications"],
      after: basvuru,
      branchId,
      entity: "application",
      entityId: basvuru.id,
      label: `${basvuru.child} başvurusu açıldı (${basvuru.source})`,
    });
  },

  guncelle(branchId, basvuru, alan, etiket) {
    return commit({
      op: "set",
      path: [...sube(branchId), "applications", { id: basvuru.id }],
      after: alan,
      branchId,
      entity: "application",
      entityId: basvuru.id,
      label: etiket,
    });
  },
};

// ---------- Öğrenci ----------
export const Ogrenciler = {
  guncelle(branchId, ogrenci, alan, etiket) {
    return commit({
      op: "set",
      path: [...sube(branchId), "students", { id: ogrenci.id }],
      after: alan,
      branchId,
      entity: "student",
      entityId: ogrenci.id,
      label: etiket ?? `${ogrenci.name} kaydı güncellendi`,
    });
  },
};

// ---------- İlaç (§5) ----------
export const Ilac = {
  /**
   * Doz uygulamasını kaydeder. Veli izni yoksa çağıran engellemeli —
   * burada da ikinci bir kontrol var: izinsiz ilaç kaydı oluşturulmaz.
   */
  uygula(branchId, med, ogrenci, kayit) {
    if (!med.consent?.at) {
      throw new Error(`${med.drugName}: veli izni kayıtlı değil, uygulanamaz.`);
    }
    return commit({
      op: "push",
      path: [...sube(branchId), "medications", { id: med.id }, "administrations"],
      after: kayit,
      branchId,
      entity: "medication",
      entityId: med.id,
      label: `${ogrenci.name} — ${med.drugName} ${kayit.dose} uygulandı`,
    });
  },
};

// ---------- Olay / kaza (§5) ----------
export const Olay = {
  olustur(branchId, olay, ogrenci) {
    return commit({
      op: "push",
      path: [...sube(branchId), "incidents"],
      after: olay,
      branchId,
      entity: "incident",
      entityId: olay.id,
      label: `${ogrenci.name} — ${olay.type} olayı kaydedildi`,
    });
  },

  veliBilgilendir(branchId, olay, ogrenci, zaman) {
    return commit({
      op: "set",
      path: [...sube(branchId), "incidents", { id: olay.id }],
      after: { parentNotifiedAt: zaman },
      branchId,
      entity: "incident",
      entityId: olay.id,
      label: `${ogrenci.name} olayı veliye bildirildi`,
    });
  },
};

// ---------- Kiracı yönetimi (süper admin) ----------
//
// Abonelik değişiklikleri denetim izine düşer: kim, ne zaman, hangi
// plandan hangi plana geçirdi. Para konuşulan her yerde bu gerekir.
export const Kiraci = {
  // Yol ALANA kadar iner (…/subscription/planId), nesnenin kendisine
  // değil. Son adım düz bir anahtar olduğunda setAt() birleştirmez,
  // değeri olduğu gibi yazar — "subscription" hedeflenseydi planId ve
  // since dahil tüm abonelik kaydı silinirdi.
  planDegistir(kiraci, yeniPlanId, eskiPlanId) {
    return commit({
      op: "set",
      path: ["tenants", { id: kiraci.id }, "subscription", "planId"],
      after: yeniPlanId,
      tenantId: kiraci.id,
      entity: "subscription",
      entityId: kiraci.id,
      label: `${kiraci.name} planı ${eskiPlanId} → ${yeniPlanId}`,
    });
  },

  durumDegistir(kiraci, yeniDurum, eskiDurum) {
    return commit({
      op: "set",
      path: ["tenants", { id: kiraci.id }, "subscription", "status"],
      after: yeniDurum,
      tenantId: kiraci.id,
      entity: "subscription",
      entityId: kiraci.id,
      label: `${kiraci.name} aboneliği ${eskiDurum} → ${yeniDurum}`,
    });
  },
};

// ---------- Bildirimler (§2) ----------
export const Bildirim = {
  okundu(branchId, key) {
    return commit({
      op: "set",
      path: [...sube(branchId), "notificationRead", key],
      after: { readAt: new Date().toISOString() },
      branchId, entity: "notification", entityId: key,
      label: `Bildirim okundu: ${key}`,
    });
  },

  kapat(branchId, key) {
    return commit({
      op: "set",
      path: [...sube(branchId), "notificationRead", key],
      after: { readAt: new Date().toISOString(), dismissedAt: new Date().toISOString() },
      branchId, entity: "notification", entityId: key,
      label: `Bildirim kapatıldı: ${key}`,
    });
  },

  /**
   * Gönderim kaydı. Kanal entegrasyonu kurulmamışsa mesaj gitmez ama
   * kayıt yine oluşur — gerçek servis bağlandığında geçmiş kaybolmasın
   * ve "veliye haber verildi mi?" sorusu cevaplanabilsin.
   */
  gonder(branchId, kayit) {
    return commit({
      op: "push",
      path: [...sube(branchId), "notificationSends"],
      after: kayit,
      branchId, entity: "notification", entityId: kayit.key,
      label: `${kayit.kanal} gönderimi — ${kayit.alici}`,
    });
  },

  kanalDegistir(branchId, kanal, acik) {
    return commit({
      op: "set",
      path: [...sube(branchId), "notificationChannels", kanal],
      after: acik,
      branchId, entity: "notification", entityId: kanal,
      label: `${kanal} kanalı ${acik ? "açıldı" : "kapatıldı"}`,
    });
  },
};

// ---------- Tahsilat hatırlatmaları (§5) ----------
export const Hatirlatma = {
  gonder(branchId, kayit) {
    return commit({
      op: "push",
      path: [...sube(branchId), "notificationSends"],
      after: kayit,
      branchId, entity: "reminder", entityId: kayit.key,
      label: `${kayit.alici} — ${kayit.basamakLabel} hatırlatması (${kayit.kanal})`,
    });
  },

  taksitPlaniAc(branchId, plan, ogrenci) {
    return commit({
      op: "push",
      path: [...sube(branchId), "installmentPlans"],
      after: plan,
      branchId, entity: "installment", entityId: plan.id,
      label: `${ogrenci.name} için ${plan.installments.length} taksitli plan açıldı`,
    });
  },

  taksitOdendi(branchId, plan, no, ogrenci) {
    const i = plan.installments.findIndex(t => t.no === no);
    return commit({
      op: "set",
      path: [...sube(branchId), "installmentPlans", { id: plan.id }, "installments", String(i), "paidAt"],
      after: new Date().toISOString().slice(0, 10),
      branchId, entity: "installment", entityId: plan.id,
      label: `${ogrenci.name} — ${no}. taksit tahsil edildi`,
    });
  },
};

// ---------- Toplu duyuru (§13) ----------
export const Duyuru = {
  olustur(branchId, duyuru) {
    return commit({
      op: "push",
      path: [...sube(branchId), "announcements"],
      after: duyuru,
      branchId, entity: "announcement", entityId: duyuru.id,
      label: `Duyuru gönderildi: ${duyuru.baslik}`,
    });
  },

  yanitla(branchId, duyuru, studentId, cevap) {
    return commit({
      op: "set",
      path: [...sube(branchId), "announcements", { id: duyuru.id }, "responses", studentId],
      after: { readAt: new Date().toISOString(), answer: cevap, at: new Date().toISOString() },
      branchId, entity: "announcement", entityId: duyuru.id,
      label: `${duyuru.baslik} — yanıt: ${cevap}`,
    });
  },

  okundu(branchId, duyuru, studentId) {
    return commit({
      op: "set",
      path: [...sube(branchId), "announcements", { id: duyuru.id }, "responses", studentId],
      after: { readAt: new Date().toISOString(), answer: null, at: null },
      branchId, entity: "announcement", entityId: duyuru.id,
      label: `${duyuru.baslik} okundu`,
    });
  },
};

// ---------- Dışa aktarma (§11) ----------
// KVKK: veri kurumdan çıkıyor, kim indirdiği kayda geçmeli.
export const Aktarim = {
  kaydet(branchId, kod, dosya) {
    return commit({
      op: "push",
      path: [...sube(branchId), "notificationSends"],
      after: {
        id: `exp-${Date.now().toString(36)}`,
        key: `aktarim:${kod}`,
        kanal: "dosya",
        alici: "—",
        aliciTipi: "aktarim",
        at: new Date().toISOString().slice(0, 16),
        metin: `${dosya.label} · ${dosya.satirSayisi} satır · ${dosya.dosyaAdi}`,
        durum: "indirildi",
      },
      branchId, entity: "export", entityId: kod,
      label: `${dosya.label} dışa aktarıldı (${dosya.satirSayisi} satır)`,
    });
  },
};

// ---------- Fotoğraf ----------
//
// Öğrenci ve personel için ortak. Kişi kaydına photoPath ve
// photoConsentAt yazar; görüntülenebilir URL Firestore'a HİÇ
// yazılmaz (gerekçesi lib/storage-dosyalar.js başında).
//
// Repo katmanından geçmesi bilinçli: fotoğrafın ne zaman, kim
// tarafından eklendiği ve silindiği denetim izine düşüyor. KVKK
// tarafında "bu çocuğun fotoğrafı ne zaman kaldırıldı" sorusunun
// cevabı olmalı.
export const Fotograf = {
  ayarla(branchId, kisi, alanlar) {
    const ogrenciMi = Object.hasOwn(kisi, "classId") && Object.hasOwn(kisi, "parent");
    const koleksiyon = ogrenciMi ? "students" : "staff";
    const eklendi = Boolean(alanlar.photoPath);

    // `photo` ALANI KAYDA GİRMEZ. İki sebep:
    //   1. O bir indirme URL'i; token taşıyor ve kuralları by-pass
    //      ediyor (bkz. lib/storage-dosyalar.js). Belgeye yazılmamalı.
    //   2. undefined bırakmak da olmaz — Firestore undefined değer
    //      içeren yazmayı reddediyor, mutasyon günlüğü düşerdi.
    // Bu yüzden alan nesneden tamamen çıkarılıyor.
    const { photo: _gorsel, ...kalan } = kisi;

    return commit({
      op: "set",
      path: [...sube(branchId), koleksiyon, { id: kisi.id }],
      after: { ...kalan, ...alanlar },
      branchId,
      entity: ogrenciMi ? "student" : "staff",
      entityId: kisi.id,
      label: `${kisi.name} fotoğrafı ${eklendi ? "güncellendi" : "kaldırıldı"}`,
    });
  },
};
